import { Component, inject } from '@angular/core';
import { SPINNER_DEFAULT_VARIANT } from '@hrra/ui';

// loading indicator for the tree selects; follows the app's SPINNER_DEFAULT_VARIANT,
// so public-web-app gets the same icon spinner as app-spinner and other apps keep primeng's spinner
@Component({
    selector: 'hrra-tree-select-spinner',
    templateUrl: './tree-select-spinner.component.html',
    styleUrls: ['./tree-select-spinner.component.scss'],
    standalone: false
})
export class TreeSelectSpinnerComponent {
  variant = inject(SPINNER_DEFAULT_VARIANT);
}
